import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Remove = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0502 8.0002C12.0502 8.30395 11.804 8.5502 11.5002 8.5502H4.5002C4.19644 8.5502 3.9502 8.30395 3.9502 8.0002C3.9502 7.69644 4.19644 7.4502 4.5002 7.4502H11.5002C11.804 7.4502 12.0502 7.69644 12.0502 8.0002Z"
        fill={color}
      />
      <circle cx="8" cy="8" r="6.5" stroke="#6D778B" strokeLinecap="round" />
    </svg>
  )
})

export default Remove
